import socket from '@/services/socket.js'
import timeBlockTransformer from '@/services/transformers/timeBlockTransformer.js'

export default {
  update(user_id, time_blocks) {
    const action = '/schedule/update'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        time_blocks
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  getByUserId(user_id) {
    let action = '/time_block/get_by_user_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        let items = data.time_blocks.map(item => timeBlockTransformer(item))
        resolve(items)
      })
    })
  }
}
